import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import storeyviewLogo from '../../assets/logos/sv_logo_green.png';
import { theme } from '../../theme';

interface HeaderProps {
  showLoginButton?: boolean;
}

const Header = ({ showLoginButton }: HeaderProps) => {
  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '20px 60px',
        '@media (max-width: 600px)': {
          padding: '16px 20px',
        },
      }}
    >
      <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center' }}>
        <img src={storeyviewLogo} alt="storeyview" style={{ height: '26px' }} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '32px',
          '@media (max-width: 600px)': { gap: '16px' },
        }}
      >
        <Typography
          component={Link}
          to="/features"
          sx={{ fontSize: '0.85rem', color: '#333', textDecoration: 'none', '@media (max-width: 600px)': { fontSize: '0.75rem' } }}
        >
          Features
        </Typography>
        <Typography
          component={Link}
          to="/support"
          sx={{ fontSize: '0.85rem', color: '#333', textDecoration: 'none', '@media (max-width: 600px)': { fontSize: '0.75rem' } }}
        >
          Support
        </Typography>
        {showLoginButton ? (
          <Button
            component={Link}
            to="/"
            variant="contained"
            sx={{
              backgroundColor: theme.palette.primary.main,
              letterSpacing: '1px',
              fontSize: '0.75rem',
              '&:hover': { backgroundColor: theme.palette.primary.main },
              '@media (max-width: 600px)': { fontSize: '0.65rem', padding: '4px 8px' },
            }}
          >
            Log In
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default Header;
